/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

module.exports = require("./DragDrop.js");
